export default "__VITE_ASSET__18a0cd17__"